<div class="modal_wrapper">
    <div class="modal_header" fxLayout="row" fxLayoutAlign="space-between">
        <h3>2 Factor Authentication</h3>
        <ion-icon (click)="modalCtrl.dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="modal_body">
        <msi-auth-two-factor-form 
            [user]="user" 
            [token]="token" 
            (pass)="modalCtrl.dismiss($event)" 
            (abort)="modalCtrl.dismiss()"
        ></msi-auth-two-factor-form>
    </div>
</div>
